import { HTMLAttributes } from "react";

/**
 * A placeholder block standing in for content that is loading. Size and shape come from
 * `className` (`h-4 w-32`, `h-10 w-10 rounded-full`…) so a skeleton is drawn with the same
 * dimensions as the element it replaces — the page must not jump when the data lands.
 */
export function Skeleton({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) {
    return <div aria-hidden className={`rounded-sm bg-surface-sunken motion-safe:animate-pulse ${className}`} {...props} />;
}
